import { useImmer } from "use-immer";

import { GetScriptStatusResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { QueryMeta, QueryOptions } from "../../types/react-query";
import { api } from "../api";
import { organizationScriptStatusKey } from "../queryKeys";

const getScriptStatus = async (themeId?: string, fullUrl?: string) => {
  const resp = await api.get<GetScriptStatusResponseBodyType>(
    "/v2/organizations/script-status",
    {
      params: {
        themeId,
        fullUrl,
      },
    }
  );
  return resp.data;
};

export const useGetScriptStatus = (
  orgId?: string,
  themeId?: string,
  fullUrl?: string,
  options?: QueryOptions<GetScriptStatusResponseBodyType, Error>
) => {
  const [isError, setIsError] = useImmer(false);
  return useQuery<GetScriptStatusResponseBodyType, Error>({
    queryKey: organizationScriptStatusKey.preview(orgId!, themeId, fullUrl),
    queryFn: async () => getScriptStatus(themeId, fullUrl),
    enabled: !isError && !!orgId,
    retry: false,
    ...options,
    meta: {
      onError: {
        any: () => setIsError(true),
      },
    } as QueryMeta,
  });
};
